import { Route, Redirect } from 'react-router-dom';
import { getRedirectRoute, verifyAuthentication } from 'utils/authentication';
import { IRoute } from './routes';

interface RoutePrivateProps extends IRoute {}

export function PrivateRoute({
  isPrivate = false,
  isPublic = false,
  component: Component,
  exact,
  path,
  ...rest
}: RoutePrivateProps): JSX.Element {
  return (
    <Route
      {...rest}
      path={path}
      exact={exact || false}
      render={props => {
        return verifyAuthentication({ isPrivate, isPublic, ...rest }) ? (
          <Component {...(props as any)} />
        ) : (
          <Redirect to={{ pathname: getRedirectRoute(isPublic) }} />
        );
      }}
    />
  );
}
